import { CERelationshipAttributeBase } from './ce-relationship-attribute-base'


export class CERelationshipAttribute extends CERelationshipAttributeBase {

}